import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
export const useGetAllSegmentService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  //Query's
  const getAllSegmentsServices = useQuery({
    queryKey: [
      ...CACHE_KEYS.SEGMENTS,
      debouncedQuery,
      per_page,
      page,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.SEGMENTS,
        searchParams: {
          "filter[name]": debouncedQuery,
          page: page,
          per_page: per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { getAllSegmentsServices },
    states: { searchQuery, setSearchQuery },
  };
};
